import React from 'react';
import styles from './ProcessingStatusIndicator.module.scss';

export type ProcessingStatus = 'processing' | 'completed' | 'failed' | 'error';

interface ProcessingStatusIndicatorProps {
    status: ProcessingStatus;
    message?: string;
    size?: 'small' | 'medium' | 'large';
    showMessage?: boolean;
}

const ProcessingStatusIndicator: React.FC<ProcessingStatusIndicatorProps> = ({
    status,
    message,
    size = 'medium',
    showMessage = true
}) => {
    const getStatusIcon = () => {
        switch (status) {
            case 'processing':
                return (
                    <div className={`${styles.spinner} ${styles[size]}`}>
                        <div className={styles.spinnerInner}></div>
                    </div>
                );
            case 'completed':
                return (
                    <div className={`${styles.icon} ${styles.completed} ${styles[size]}`}>
                        ✓
                    </div>
                );
            case 'failed':
            case 'error':
                return (
                    <div className={`${styles.icon} ${styles.error} ${styles[size]}`}>
                        ✕
                    </div>
                );
            default:
                return null;
        }
    };

    const getStatusText = () => {
        if (message) return message;
        
        switch (status) {
            case 'processing':
                return 'Обработка...';
            case 'completed':
                return 'Готово';
            case 'failed':
            case 'error':
                return 'Ошибка';
            default:
                return '';
        }
    };

    const getStatusClass = () => {
        return `${styles.indicator} ${styles[status]} ${styles[size]}`;
    };

    return (
        <div className={getStatusClass()}>
            {getStatusIcon()}
            {showMessage && (
                <span className={styles.message}>
                    {getStatusText()}
                </span>
            )}
        </div>
    );
};

export default ProcessingStatusIndicator;
